module.exports = {
  /* Start - Main schema validation */
  type: 'object',
  optional: ['annotationsData'],
  properties: {
    id: { type: ['number', 'string'] },
    appID: { type: ['number', 'string'] },
    appName: { type: ['number', 'string'] },
    componentID: { type: ['number', 'string'] },
    annotationsData: {
      type: ['null', 'array'],
      items: {
        type: 'object',
        additionalProperties: true,
        properties: {
          data: {
            type: 'object',
            properties: {
              x: { type: ['number', 'string'] },
              y: { type: ['number', 'string'] }
            }
          },
          subject: {
            type: 'object',
            properties: {
              x: { type: ['number', 'string'] },
              y: { type: ['number', 'string'] },
              text: { type: ['number', 'string'] },
              radius: { type: ['number', 'string'] },
              radiusPadding: { type: ['number', 'string'] }
            }
          },
          disable: {
            type: ['null', 'array'],
            items: {}
          }
        }
      }
    },
    config: {
      type: 'object',
      //maxProperties: 8,
      //minProperties: 8,
      //required: ["width", "height", "xAxis", "yAxis", "series"],
      //optional: ["width", "height", "xAxis", "yAxis", "series"],
      additionalProperties: false,
      /* End - Main schema validation */
      optional: ['data', 'maxBarWidth', 'title', 'subtitle', 'globalTooltip', 'legend', 'childComponentConfigs', 'maxAxisLabelChar', 'onLegendClick', 'closeIconStyle', 'containerId'],
      /* Start - Main schema inner props validation */
      properties: {
        width: { type: ['number', 'string'], size: {} }, //, not: { minimum: 10 } },

        height: { type: ['number', 'string'], size: {} },

        data: { type: ['null', 'array'], items: { type: 'object' } },

        maxBarWidth: { type: ['number', 'string'], size: {},
                /*dependencyTag:{
                  anyOf:[
                    {
                      if: { type: 'string', "enum": [ '' ] },
                      then: { 
                        value: {
                          anyOf:
                          [
                            {
                              path:['..','series','__anyOf__','type'], 
                              validation: {  type: 'string', "enum": [ 'column' ] }
                            }
                          ]
                        }
                      }
                    }
                    
                  ]
                } */
              },

        maxAxisLabelChar: { type: 'number' },

        type: { type: 'string' },

        title: {
          type: 'object',
          optional: ['style', 'text'],
          properties: {
            text: { type: 'string' },
            style: {
              type: 'object',
              optional: ['fill', 'fontSize', 'color'],
              properties: {
                fill: { type: 'string', color: {} },
                fontSize: { type: ['number', 'string'], size: {} },
                color: {
                  type: 'string',
                  color: {}
                }
              }
            }
          }
        },

        subtitle: {
          type: 'object',
          optional: ['style', 'text'],
          properties: {
            text: { type: 'string' },
            style: {
              type: 'object',
              optional: ['fill', 'fontSize', 'color'],
              properties: {
                fill: { type: 'string', color: {} },
                fontSize: { type: ['number', 'string'], size: {} },
                color: { type: 'string', color: {} }
              }
            }
          }
        },

        margins: {
          type: 'object',
          properties: {
            top: { type: 'number' },
            right: { type: 'number' },
            bottom: { type: 'number' },
            left: { type: 'number' }
          }
        },

        xAxis: {
          type: 'array',
          items: {
            type: 'object',
            optional: ['crosshair', 'tickLineRequired', 'zeroBase', 'title', 'tickPrefix', 'tickWidth', 'tickFormat', 'tickColor', 'tickSize', 'lineWidth', 'lineColor', 'gridLineWidth', 'labels', 'translate'],
            properties: {
              // TODO: should the type be string, or it is based on Data
              categories: {
                type: 'array',
                items: {
                  oneOf: [
                    {
                      type: ['number']
                    },
                    {
                      type: ['string']
                    },
                    {
                      type: ['object'],
                      properties: {}
                      // allow additionalProperties?
                    },
                    {
                      type: ["null"]
                    }
                  ]
                }
              },
              orient: {
                type: 'string',
                horizontalOrient: {}
                //"enum": ["top", "bottom", "right", "left", "Top", "Bottom", "Right", "Left"]
              },
              crosshair: { type: 'boolean' },
              tickLineRequired: { type: 'boolean' },
              zeroBase: { type: 'boolean' },
              title: {
                type: 'object',
                optional: ['text', 'style'],
                properties: {
                  text: { type: 'string' },
                  style: {
                    type: 'object',
                    optional: ['fill', 'fontSize', 'color'],
                    properties: {
                      fill: { type: 'string', color: {} },
                      fontSize: { type: ['number', 'string'], size: {}
                        },
                      color: { type: 'string', color: {} }
                    }
                  }
                }
              },
              tickPrefix: { type: 'string' },
              tickWidth: { type: ['number', 'string'] },
              tickFormat: { type: 'string' },
              tickColor: { type: 'string', color: {} },
              tickSize: { type: 'number' },
              lineWidth: { type: 'number'},
              lineColor: { type: 'string', color: {} },
              gridLineWidth: { type: 'number' },
              labels: {
                type: 'object',
                optional: ['style', 'rotation', 'formatter', 'format', 'prefix', 'postfix'],
                properties: {
                  style: {
                    type: 'object',
                    optional: ['fill', 'fontSize', 'color'],
                    properties: {
                      fill: { type: 'string', color: {} },
                      fontSize: { type: ['number', 'string'], size: {} },
                      color: { type: 'string', color: {} }
                    }
                  },
                  rotation: { type: 'number' },
                  formatter: { function: null },
                  format: {
                    oneOf: [{ type: ['string', 'null'] }, { function: {} }]
                  },
                  prefix: { type: 'string' },
                  postfix: { type: 'string' }
                }
              },
              translate: { type: 'string', translate: {} }
            }
          }
        },

        yAxis: {
          type: 'array',
          items: {
            type: 'object',
            optional: ['categories', 'crosshair', 'zeroBase', 'title', 'ticks', 'tickPrefix', 'tickWidth', 'tickFormat', 'tickSize', 'tickColor', 'tickLineRequired', 'lineWidth', 'lineColor', 'gridLineWidth', 'labels', 'isStackLabelsRequired', 'stackLabels', 'opposite', 'translate', 'tickColor'],
            properties: {
              categories: {
                type: 'array',
                items: {
                  oneOf: [
                    {
                      type: ['number']
                    },
                    {
                      type: ['string']
                    },
                    {
                      type: ['object'],
                      properties: {}
                      // allow additionalProperties?
                    }
                  ]
                }
              },
              orient: {
                type: 'string',
                verticalOrient: {}
                //"enum": ["right", "left"]
              },
              opposite: { type: 'boolean' },
              crosshair: { type: 'boolean' },
              zeroBase: { type: 'boolean' },
              title: {
                type: 'object',
                optional: ['text', 'style'],
                properties: {
                  text: { type: 'string' },
                  style: {
                    type: 'object',
                    optional: ['fill', 'fontSize', 'color'],
                    properties: {
                      fill: { type: 'string', color: {} },
                      fontSize: { type: ['number', 'string'], size: {} },
                      color: { type: 'string', color: {} }
                    }
                  }
                }
              },
              ticks: { type: 'number' },
              tickPrefix: { type: 'string' },
              tickWidth: { type: 'number' },
              tickFormat: { type: 'string' },
              tickSize: { type: 'number' },
              tickColor: { type: 'string', color: {} },
              tickLineRequired: { type: 'boolean' },
              lineWidth: { type: 'number' },
              lineColor: { type: 'string', color: {} },
              gridLineWidth: { type: 'number' },
              labels: {
                type: 'object',
                optional: ['style', 'rotation', 'formatter', 'format', 'prefix', 'postfix'],
                properties: {
                  style: {
                    type: 'object',
                    optional: ['fill', 'fontSize', 'color', 'textAnchor'],
                    properties: {
                      fill: { type: 'string', color: {} },
                      fontSize: { type: ['number', 'string'], size: {} },
                      color: { type: 'string', color: {} },
                      textAnchor: {
                        type: 'string',
                        anchorPosition: {}
                        //"enum": ["start", "end", "middle"]},//, "START", "END", "MIDDLE"] },
                      }
                    }
                  },
                  rotation: { type: 'number' },
                  formatter: {'AnyOf': [{ type: 'string' }, { 'function': null }]},
                  format: { type: 'string' },
                  prefix: { type: 'string' },
                  postfix: { type: 'string' }
                }
              },

              isStackLabelsRequired: {
                type: 'boolean'
              },

              stackLabels: {
                type: 'object',
                optional: ['enabled', 'style', 'rotation', 'formatter', 'format', 'prefix', 'postfix'],
                properties: {
                  enabled: { type: 'boolean' },
                  format: { type: 'string' },
                  style: {
                    type: 'object',
                    optional: ['fill', 'fontSize', 'color'],
                    properties: {
                      fill: { type: 'string', color: {} },
                      fontSize: { type: ['number', 'string'], size: {} },
                      color: { type: 'string', color: {} }
                    }
                  },
                  rotation: { type: 'number' },
                  formatter: { function: null },
                  format: {
                    oneOf: [{ type: ['string', 'null'] }, { function: {} }]
                  },
                  prefix: { type: 'string' },
                  postfix: { type: 'string' }
                }
              },
              translate: { type: 'string', translate: {} }
            }
          }
        },

        globalTooltip: {
          type: ['object', 'boolean'],
          optional: ['lineStyle'],
          properties: {
            lineStyle: {
              type: 'object',
              optional: ['stroke', 'strokeOpacity', 'strokeDasharray', 'strokeWidth'],
              properties: {
                "stroke": { type: "string", color: {} },
                "strokeOpacity": { type: "number" },
                "strokeDasharray": { type: "number" },
                "strokeWidth": { type: ["number","string"], size: {} },
              }
            }
          }
        },

        series: {
          type: 'array',
          items: {
            type: 'object',
            optional: ['type', 'yAxis', 'name', 'fillColor', 'lineStyle', 'stacking', 'dataLabels', 'marker', 'tooltip', 'tooltipPosition', 'tooltipStyle', 'closeIconStyle', 'hoverStyle', 'path', 'onStackBarClick', 'tooltipConfig', 'isPartOfGroupBar', 'isPartOfStackBar'],
            properties: {
              type: { type: 'string', graphType: {} },
              yAxis: { type: 'number', minimum: 0, maximum: 1 },
              name: { type: 'string' },
              fillColor: {
                type: ['object', 'string'],
                color: {},
                optional: ['linearGradient', 'stops'],
                properties: {
                  linearGradient: {
                    type: 'array',
                    items: { type: 'number' }
                  },
                  stops: {
                    type: 'array',
                    items: {
                      gradient: {}
                    }
                  }
                }
              },
              data: { type: 'array' },
              dataLabels: {
                type: 'object',
                optional: ['enabled', 'style', 'rotation', 'formatter', 'format', 'prefix', 'postfix', 'enabledLower', 'styleLower', 'formatLower', 'enabledUpper', 'styleUpper', 'formatUpper'],
                properties: {
                  enabled: { type: 'boolean' },
                  style: {
                    type: 'object',
                    optional: ['fill', 'fontSize', 'color', 'textAnchor'],
                    properties: {
                      fill: { type: 'string', color: {} },
                      fontSize: { type: ['number', 'string'], size: {} },
                      color: { type: 'string', color: {} },
                      textAnchor: {
                        type: 'string',
                        textAnchorPosition: {}
                        //"enum": ["start", "end", "middle"]},
                      }
                    }
                  },
                  rotation: { type: 'number' },
                  formatter: { function: null },
                  format: {
                    oneOf: [{ type: ['string', 'null'] }, { function: {} }]
                  },
                  prefix: { type: 'string' },
                  postfix: { type: 'string' },

                  enabledLower: { type: 'boolean' },
                  styleLower: {
                    type: 'object',
                    optional: ['fill', 'fontSize', 'color', 'textAnchor'],
                    properties: {
                      fill: { type: 'string', color: {} },
                      fontSize: { type: ['number', 'string'], size: {} },
                      color: { type: 'string', color: {} },
                      textAnchor: {
                        type: 'string',
                        textAnchorPosition: {}
                        //"enum": ["start", "end", "middle"]},
                      }
                    }
                  },
                  formatLower: {
                    oneOf: [{ type: ['string', 'null'] }, { function: {} }]
                  },

                  enabledUpper: { type: 'boolean' },
                  styleUpper: {
                    type: 'object',
                    optional: ['fill', 'fontSize', 'color', 'textAnchor'],
                    properties: {
                      fill: { type: 'string', color: {} },
                      fontSize: { type: ['number', 'string'], size: {} },
                      color: { type: 'string', color: {} },
                      textAnchor: {
                        type: 'string',
                        textAnchorPosition: {}
                        //"enum": ["start", "end", "middle"]},
                      }
                    }
                  },
                  formatUpper: {
                    oneOf: [{ type: ['string', 'null'] }, { function: {} }]
                  }
                }
              },
              tooltipConfig: {
                type: 'object',
                additionalProperties: true
              },

              isPartOfGroupBar: {
                type: ['integer', 'boolean'],
                minimum: 0,
                maximum: 1,
                dependencyTag:{
                  anyOf:[
                    {
                      if: { type: 'boolean', "enum": [ true ] },
                      then: { 
                        value: {
                          anyOf:
                          [
                            {
                              path:['..','type'], 
                              validation: {  type: 'string', "enum": [ 'column' ] }
                            }
                          ]
                        }
                      }
                    }
                    
                  ]
                } 
              },
              isPartOfStackBar: {
                type: ['integer', 'boolean'],
                minimum: 0,
                maximum: 1,
                dependencyTag:{
                  anyOf:[
                    {
                      if: { type: 'boolean', "enum": [ true ] },
                      then: { 
                        value: {
                          anyOf:
                          [
                            {
                              path:['..','type'], 
                              validation: {  type: 'string', "enum": [ 'column' ] }
                            }
                          ]
                        }
                      }
                    }
                    
                  ]
                } 
              },
              lineStyle: {
                type: 'object',
                optional: ['fillColor', 'fillColorUpper', 'fillColorLower', 'strokeOpacityUpper', 'strokeOpacityLower'],
                properties: {
                  fillColor: { type: 'string', color: {} },
                  fillColorUpper: {
                    type: ['object', 'string'],
                    color: {},
                    optional: ['linearGradient', 'stops'],
                    properties: {
                      linearGradient: {
                        type: 'array',
                        items: { type: 'number' }
                      },
                      stops: {
                        type: 'array',
                        items: {
                          gradient: {}
                        }
                      }
                    }
                  },
                  fillColorLower: {
                    type: ['object', 'string'],
                    color: {},
                    optional: ['linearGradient', 'stops'],
                    properties: {
                      linearGradient: {
                        type: 'array',
                        items: { type: 'number' }
                      },
                      stops: {
                        type: 'array',
                        items: {
                          gradient: {}
                        }
                      }
                    }
                  },
                  strokeOpacityUpper: { type: 'number', minimum: 0, maximum: 1 },
                  strokeOpacityLower: { type: 'number', minimum: 0, maximum: 1 }
                }
              },

              stacking: { 
                type: 'string',
                dependencyTag:{
                  anyOf:[
                    {
                      if: { type: 'string', "enum": [ 'none' ] },
                      then: { 
                        value: {
                          anyOf:
                          [
                            {
                              path:['..','type'], 
                              validation: {  type: 'string', "enum": [ 'column' ] }
                            }
                          ]
                        }
                      }
                    }
                    
                  ]
                } 
              },
              onStackBarClick: { function: {} },
              marker: {
                type: 'object',
                optional: ['enabled', 'symbol', 'fillColor', 'radius', 'radiusUpper', 'radiusLower', 'fillColorUpper', 'fillColorLower'],
                properties: {
                  enabled: { type: 'boolean' },
                  symbol: { type: 'string' },

                  fillColor: {
                    type: ['object', 'string'],
                    color: {},
                    optional: ['linearGradient', 'stops'],
                    properties: {
                      linearGradient: {
                        type: 'array',
                        items: { type: 'number' }
                      },
                      stops: {
                        type: 'array',
                        items: {
                          gradient: {}
                        }
                      }
                    }
                  },
                  radius: { type: ['string', 'number'] },

                  fillColorUpper: {
                    type: ['object', 'string'],
                    color: {},
                    optional: ['linearGradient', 'stops'],
                    properties: {
                      linearGradient: {
                        type: 'array',
                        items: { type: 'number' }
                      },
                      stops: {
                        type: 'array',
                        items: {
                          gradient: {}
                        }
                      }
                    }
                  },
                  radiusUpper: { type: 'string' },

                  fillColorLower: {
                    type: ['object', 'string'],
                    color: {},
                    optional: ['linearGradient', 'stops'],
                    properties: {
                      linearGradient: {
                        type: 'array',
                        items: { type: 'number' }
                      },
                      stops: {
                        type: 'array',
                        items: {
                          gradient: {}
                        }
                      }
                    }
                  },
                  radiusLower: { type: 'string' }
                }
              },
              tooltip: {
                type: ['boolean', 'object','array'],
                properties: {
                  component: {}
                },
                items:{
                  type:'object',
                  properties:{'displayName':{type:'string'},'fieldName':{type:'string'}}
                }
              },
              tooltipPosition: {
                type: 'string',
                tooltipPlacement: {}
                //"enum":["cursor"]
              },
              tooltipStyle: {
                type: 'object',
                optional: ['format', 'labelFontSize', 'labelFontColor', 'labelFontFamily', 'valueFontSize', 'valueFontColor', 'valueFontFamily', 'valueFormat', 'valuePrefix', 'valuePostfix'],
                properties: {
                  format: {
                    oneOf: [{ type: ['string', 'null'] }, { function: {} }]
                  },
                  labelFontSize: { type: ['number', 'string'], size: {} },
                  labelFontColor: { type: 'string', color: {} },
                  labelFontFamily: { type: 'string' },
                  valueFontSize: { type: ['number', 'string'], size: {} },
                  valueFontColor: { type: 'string', color: {} },
                  valueFontFamily: { type: 'string' },
                  valueFormat: { type: 'string' },
                  valuePrefix: { type: 'string' },
                  valuePostfix: { type: 'string' }
                }
              },
              closeIconStyle: {
                type: 'object',
                optional: ['fill'],
                properties: {
                  fill: { type: 'string', color: {} }
                }
              },
              hoverStyle: {
                type: 'object',
                optional: ['labelStyle', 'barStyle'],
                properties: {
                  labelStyle: {
                    type: 'object',
                    optional: ['fontSize', 'fontWeight'],
                    properties: {
                      fontSize: { type: ['number', 'string'], size: {} },
                      fontWeight: {
                        type: 'string',
                        fontWeightStyle: {}
                        //"enum":["normal","bold","bolder","lighter",100,200,300,400,500,600,700,800,900,"inherit","initial"]
                      }
                    }
                  },
                  barStyle: {
                    type: 'object',
                    optional: ['fill'],
                    properties: {
                      fill: { type: 'string', color: {} }
                    }
                  }
                }
              },

              path: {
                type: 'object',
                optional: ['enabledUpper', 'enabledLower', 'fillOpacityUpper', 'fillOpacityLower', 'fillColorUpper', 'fillColorLower'],
                properties: {
                  enabledUpper: { type: 'boolean' },
                  fillOpacityUpper: { type: ['boolean', 'number'] },
                  fillColorUpper: {
                    type: ['object', 'string'],
                    color: {},
                    optional: ['linearGradient', 'stops'],
                    properties: {
                      linearGradient: {
                        type: 'array',
                        items: { type: 'number' }
                      },
                      stops: {
                        type: 'array',
                        items: {
                          gradient: {}
                        }
                      }
                    }
                  },

                  enabledLower: { type: 'boolean' },
                  fillOpacityLower: { type: ['boolean', 'number'] },
                  fillColorLower: {
                    type: ['object', 'string'],
                    color: {},
                    optional: ['linearGradient', 'stops'],
                    properties: {
                      linearGradient: {
                        type: 'array',
                        items: { type: 'number' }
                      },
                      stops: {
                        type: 'array',
                        items: {
                          gradient: {}
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        },

        legend: {
          type: 'array',
          items: {
            type: 'object',
            optional: ['enableLegendClick', 'floating', 'title', 'labelFontSize', 'typeofscale', 'labelFontColor', 'isSeriesDisabled'],
            properties: {
              layout: { type: 'string', layout: {} },
              enableLegendClick: { type: 'boolean' },
              labels: {
                type: 'array',
                items: {
                  type: 'string'
                }
              },
              domain: {
                type: 'array',
                items: { type: ['number', 'string'] }
              },
              range: {
                type: 'array',
                items: {
                  color: {}
                }
              },
              displayInLine: {
                type: 'object',
                optional: ['rectWidth'],
                properties: {
                  rectWidth: { type: 'number' }
                }
              },
              align: { type: 'string', verticalOrient: {} },
              x: { type: 'number' },
              y: { type: 'number' },
              verticalAlign: { type: 'string', horizontalOrient: {} },
              floating: { type: 'boolean' },
              rectWidth: { type: 'number' },
              labelWrap: { type: 'number' },
              labelFontColor: { type: 'string', color: {} },
              isSeriesDisabled: { type: 'boolean' },
              rectPadding: { type: 'number' },
              title: { type: 'string' },
              labelFontSize: {
                type: ['number', 'string'],
                size: {}
              },
              typeofscale: { type: 'string', typeofscale: {} }
            }
          }
        },
        childComponentConfigs: {
          type: 'array',
          items: {
            type: 'object',
            additionalProperties: true
          }
        },
        "onLegendClick": {
          function: {}
        },
        closeIconStyle: {
          type: 'object',
          optional: ['fill'],
          properties: {
            fill: { type: 'string', color: {} }
          }
        },

        containerId: { type: 'string' }
      }
    }
  }

  /* End - Main schema inner props validation */

  /*This is for custom error message for our user
   errorMessage: {
     required: 'should have property foo',
     additionalProperties: 'should not have properties other than foo'
   },*/
};
